/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const ProjectContentPage = () => {
  const { projectContentApi } = apiPath;
  const [homeProject, projectLoading] = useFetch(projectContentApi);
  if (projectLoading) {
    return <Loading />;
  }
  const { projectContentBg, projectContentTitle } = homeProject;

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "Text",
      name: "projectContentBg",
      defaultValue: projectContentBg,
      required: true,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "projectContentTitle",
      defaultValue: projectContentTitle,
      required: true,
    },
  ];

  const update = (data) => {
    updateData(projectContentApi, data);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ProjectContentPage;
